'use client';

import { useEffect } from 'react';

export function DevToolsProtection() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // Disable keyboard shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+I (DevTools) - Windows/Linux
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }
      
      // Cmd+Option+I (DevTools) - Mac
      if (e.metaKey && e.altKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+J (Console) - Windows/Linux
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return false;
      }
      
      // Cmd+Option+J (Console) - Mac
      if (e.metaKey && e.altKey && e.key === 'J') {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+U (View Source) - Windows/Linux
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }
      
      // Cmd+U (View Source) - Mac
      if (e.metaKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+C (Element Inspector) - Windows/Linux
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        return false;
      }
      
      // Cmd+Shift+C (Element Inspector) - Mac
      if (e.metaKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        return false;
      }
      
      // Cmd+Option+C (Element Inspector) - Mac alternative
      if (e.metaKey && e.altKey && e.key === 'C') {
        e.preventDefault();
        return false;
      }

      // Additional Mac shortcuts (case insensitive)
      // Cmd+Shift+C (case insensitive)
      if (e.metaKey && e.shiftKey && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault();
        return false;
      }

      // Cmd+Option+C (case insensitive)
      if (e.metaKey && e.altKey && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault();
        return false;
      }

      // Cmd+Shift+I (case insensitive)
      if (e.metaKey && e.shiftKey && (e.key === 'i' || e.key === 'I')) {
        e.preventDefault();
        return false;
      }

      // Cmd+Shift+J (case insensitive)
      if (e.metaKey && e.shiftKey && (e.key === 'j' || e.key === 'J')) {
        e.preventDefault();
        return false;
      }
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    
    // Try with capture phase
    document.addEventListener('keydown', handleKeyDown, true);
    
    // Try on window as well
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keydown', handleKeyDown, true);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keydown', handleKeyDown, true);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  return null; // This component doesn't render anything
} 